import { useCallback, useEffect, useState } from 'react'

import { getAPIClient } from 'api/axios'

import { CouponDetail } from '../types/coupon'

interface UseGetCouponState {
  coupon: CouponDetail | null
  loading: boolean
  error: string | null
}

export const useGetCoupon = (uuid: string | null) => {
  const [state, setState] = useState<UseGetCouponState>({
    coupon: null,
    loading: false,
    error: null
  })

  const client = getAPIClient()

  const fetchCoupon = useCallback(async () => {
    if (!uuid) return

    setState((prev) => ({ ...prev, loading: true, error: null }))

    try {
      const response = await client.get(`/v1/coupons/${uuid}`)
      const data = response.data

      const record = data.record || data.coupon || data
      setState({
        coupon: {
          ...record,
          discount_value: Number(record.discount_value),
          max_discount:
            record.max_discount != null ? Number(record.max_discount) : null
        },
        loading: false,
        error: null
      })
    } catch (err: any) {
      setState((prev) => ({
        ...prev,
        loading: false,
        error: err?.response?.data?.message || 'Erro ao carregar cupom'
      }))
    }
  }, [uuid])

  useEffect(() => {
    fetchCoupon()
  }, [fetchCoupon])

  return {
    ...state,
    refetch: fetchCoupon
  }
}
